import React from 'react';
import { Stack, Icon, P } from '@fashionnovateam/nova-ui-toolkit';

export function PageNotFound() {
  return (
    <Stack direction="col" content="center" gap="md" className="w-full h-full">
      <Icon.FileSearch variant="solid" className="text-3xl text-primary-700" />
      <Stack direction="col" gap="sm" align="center">
        <P size="3xl" color="primary" weight="medium">
          Oops! Page not found.
        </P>
        <P size="md" color="secondary" weight="normal">
          Sorry, we couldn&apos;t find the page you where looking for.
        </P>
      </Stack>
    </Stack>
  );
}
